<template lang="html">
	<div class="friend" v-bind:title="friend.online > 3 ? 'Last online: ' + getTimeAgo(friend.online) : ''">
		<span class="indicator" v-bind:class="{'online': friend.online < 3}"></span>
		<v-btn text class="title col" @click="goTo(friend)">
			{{ friend.name }}
		</v-btn>
		<div style="flex: 1;">
		<v-btn v-if="friend.status == 'Success'" v-on:click="friendRequest(friend.id, 'Decline', friend)" color="cancel" title="Decline">Remove</v-btn>
		<v-btn v-if="friend.status == 'Decline'" v-on:click="friendRequest(friend.id, 'Success', friend)" color="success" title="Success">Accept</v-btn>
		<v-btn v-if="friend.status == 'Request'" v-on:click="friendRequest(friend.id, 'Success', friend)" color="success" title="Success">Accept</v-btn>
		<v-btn v-if="friend.status == 'Request'" v-on:click="friendRequest(friend.id, 'Decline', friend)" color="cancel" title="Decline">Remove</v-btn>
		</div>
	</div>
</template>

<script>
import api from "../api";
const moment = require("moment");
export default {
  name: "friend",
  props: ["friend"],
  data() {
    return {
      name: {
        first: "First",
        last: "Lastname",
      },
      online: false,
    };
  },
  computed: {},
  methods: {
    friendRequest(id, type, item) {
      if (type != "Decline") {
        return api.friendRequest(id, type, item, this);
      }
      var me = this;
      me.$dialog.confirm({
        title: "Warning",
        text: "Do you really want to remove this friend?",
        actions: {
          false: {
            text: "Cancel",
          },
          true: {
            text: "Yes",
            variant: "danger",
            handle: function () {
              api.friendRequest(id, type, item, me);
            },
          },
        },
      });
    },
    goTo(item) {
      console.log(this);
      this.$store.state.calendar = {
        id: item.uid,
        name: item.name,
      };
      this.$store.state.isUpdate = true;
      this.$store.dispatch("updateData");
      this.$parent.$parent.$parent.hide();
    },
    getTimeAgo(min) {
      return moment().subtract(min, "minute").fromNow();
    },
  },
};
</script>

<style scoped lang="scss">
.friend {
  display: flex;
  align-items: center;
  padding: 1rem;
  color: #333;
  &:last-child {
    padding-bottom: 0;
  }
  img {
    display: inline;
    width: 3rem;
    height: 3rem;
    border-radius: 999px;
  }
  .title {
    flex-grow: 4;
    padding: 0 0.4rem;
    display: inline;
    width: 100%;
    white-space: normal;
    font-size: 1.2rem;
    height: auto !important;
  }
  .indicator {
    min-width: 10px;
    min-height: 10px;
    background: #999;
    border-radius: 999px;
    margin-left: 10px;
    &.online {
      background: #0f9;
    }
  }
}
.success {
  color: rgb(0, 155, 0) !important;
}
.cancel {
  color: rgb(155, 0, 0) !important;
}
</style>